import React from 'react';
import './App.css';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { BrandCards } from './components/BrandCards';
import { Services } from './components/Services';
import { VehicleGallery } from './components/VehicleGallery';
import { VehicleInventory } from './components/VehicleInventory';
import { TrustSection } from './components/TrustSection';
import { LocationsMap } from './components/LocationsMap';
import { Footer } from './components/Footer';
import { MobileStickyBar } from './components/MobileStickyBar';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { CountdownBanner } from './components/CountdownBanner';
import { EventHero } from './components/EventHero';
import { CookieBanner } from './components/CookieBanner';
import { mockData } from './mock';

function App() {
  return (
    <div className="App pb-16 md:pb-0">
      <Header dealershipName={mockData.dealership.name} />
      <CountdownBanner />
      <Hero dealership={mockData.dealership} />
      <EventHero />
      <BrandCards locations={mockData.locations} />
      <VehicleGallery />
      <Services services={mockData.services} />
      <VehicleInventory />
      <TrustSection />
      <LocationsMap 
        locations={mockData.locations}
      />
      <Footer dealershipName={mockData.dealership.name} />
      <MobileStickyBar />
      <FloatingWhatsApp />
      <CookieBanner />
    </div>
  );
}

export default App;
